import { mdStyle, smStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const CoinTopBorderStyled = styled.div`
  width: 100%;
  background-color: var(--color-bg-1);
  z-index: 10000000;
  position: sticky;
  top: 48px;

  &[data-issticky='true'] {
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100vw;
      height: 1px;
      background-color: var(--color-divider-2);
    }
  }
`

export const CoinTopStyled = styled.div`
  width: 100%;
  /* background-color: var(--color-bg-1); */
  z-index: 10000000;
  position: sticky;
  top: 48px;

  .coin-top {
    align-items: center;

    &--title {
      width: calc(384px - 24px - 80px - 48px);
      font-size: 16px;
      max-width: 230px;
      vertical-align: baseline;
      align-items: baseline;

      ${smStyle} {
        font-size: 18px;
      }

      ${mdStyle} {
        font-size: 20px;
      }

      .text {
        font-size: 12px;
        margin-left: 4px;

        ${smStyle} {
          font-size: 14px;
        }

        ${mdStyle} {
          font-size: 16px;
        }
      }
    }

    ${mdStyle} {
      display: grid;
      grid-template-columns: 384px 1fr;
      gap: 40px;
    }

    &[data-issticky='true'] {
      height: 56px;
    }
  }

  .coin-top-h5 {
    align-items: center;

    &--title {
      width: calc(384px - 24px - 80px - 48px);
      font-size: 16px;
      max-width: 230px;
      vertical-align: baseline;
      align-items: baseline;

      ${smStyle} {
        font-size: 18px;
      }

      ${mdStyle} {
        font-size: 20px;
      }

      .text {
        font-size: 12px;
        margin-left: 4px;

        ${smStyle} {
          font-size: 14px;
        }

        ${mdStyle} {
          font-size: 16px;
        }
      }
    }

    ${mdStyle} {
      display: grid;
      grid-template-columns: 384px 1fr;
      gap: 40px;
    }

    &[data-issticky='true'] {
      height: 56px;
    }
  }
`

export const CoinTopH5Styled = styled.div`
  .coin-top {
    align-items: center;

    &--title {
      width: calc(100vw - 24px - 80px - 48px);
      font-size: 18px;
      vertical-align: baseline;
      align-items: baseline;

      ${smStyle} {
        font-size: 20px;
        width: calc(100vw - 24px - 80px - 48px);
      }

      ${mdStyle} {
        font-size: 20px;
        width: calc(384px - 24px - 80px - 48px);
        max-width: 230px;
      }

      .text {
        font-size: 12px;
        margin-left: 4px;

        ${smStyle} {
          font-size: 14px;
        }

        ${mdStyle} {
          font-size: 16px;
        }
      }
    }

    ${mdStyle} {
      display: grid;
      grid-template-columns: 384px 1fr;
      gap: 40px;
    }

    &[data-issticky='true'] {
      height: 56px;
    }
  }

  .coin-overview-id {
    position: absolute;
    top: calc(var(--root-header-height) + var(--coin-top-height) - 40px);
  }
`

export const FiatBoxStyled = styled.div`
  width: 100%;

  /* .coin-detail-fait-list {
    display: flex;
    flex-direction: column;
    max-height: calc(80vh - 130px);
    overflow-y: auto;
    padding-right: 8px;

    ${smStyle} {
      max-height: 240px;
    }
  } */
`

export const CoinDetailFaitList = styled(Flex)`
  display: flex;
  flex-direction: column;
  /* max-height: calc(80vh - 130px); */
  max-height: calc(60vh - 56px - 48px - 8px);
  overflow-y: auto;
  padding-left: 8px;
  padding-right: 8px;

  ${smStyle} {
    max-height: 240px;
  }
`

export const FaititemStyled = styled(Flex)`
  width: calc(100% - 16px);
  padding: 8px 8px;
  cursor: pointer;
  position: relative;
  margin-top: 2px;
  margin-bottom: 2px;
  &:hover {
    background: var(--color-neutral-2);
    border-radius: 6px;
  }

  .fait {
    color: var(--color-text-1);

    &[data-select='true'] {
      color: var(--color-text-5);
    }
  }
`
